var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperty1Master(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9682 6.45557H9.01465V17.1517H14.9682V6.45557Z",
    fill: "#FF5A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41073 11.8034C9.41073 9.6303 10.4323 7.70156 12 6.45536C10.8463 5.54824 9.39091 5 7.80344 5C4.04283 5 1 8.04283 1 11.8034C1 15.5641 4.04283 18.6069 7.80344 18.6069C9.39091 18.6069 10.8463 18.0586 12 17.1515C10.4301 15.9229 9.41073 13.9766 9.41073 11.8034Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.8034C23 15.5641 19.9572 18.6069 16.1966 18.6069C14.6091 18.6069 13.1537 18.0586 12 17.1515C13.5875 15.9031 14.5893 13.9766 14.5893 11.8034C14.5893 9.6303 13.5677 7.70156 12 6.45536C13.1515 5.54824 14.6069 5 16.1944 5C19.9572 5 23 8.06265 23 11.8034Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Master);
export default __webpack_public_path__ + "static/media/Property 1=master.836fc8789641f1e7b53fc101b43cea56.svg";
export { ForwardRef as ReactComponent };